import { useEffect, useState } from "react";
import { BadgeCheck, Percent, Truck } from "lucide-react";
import { useStore } from "@/context/StoreContext";

const ICONS = { truck: Truck, percent: Percent, badge: BadgeCheck };
const FALLBACK = [
  { icon: "truck", text: "Free insured shipping across India" },
  { icon: "percent", text: "Extra 5% off on prepaid orders" },
  { icon: "badge", text: "Certified purity · BIS hallmarked gold", requires_bis: true },
];

export default function AnnouncementBar() {
  const { config } = useStore();
  const bisOk = Boolean(config?.legal?.bis_reg);
  // BIS claim only ever shows while the registration field is populated.
  const items = (config?.announcements?.length ? config.announcements
    : config?.announcement ? [{ icon: "", text: config.announcement }] : FALLBACK)
    .filter((a) => !a.requires_bis || bisOk);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 4000);
    return () => clearInterval(t);
  }, [items.length]);

  const item = items[idx % items.length];
  const Icon = ICONS[item.icon] || null;

  return (
    <div className="bg-brand text-ivory/90 text-center text-xs tracking-wide py-1.5 px-3" data-testid="announcement-bar">
      <span key={idx} className="inline-flex items-center gap-2 animate-fade-up">
        {Icon && <Icon size={13} className="text-gold" />}
        <span data-testid="announcement-text">{item.text}</span>
      </span>
    </div>
  );
}
